$('body').attr('data-url', window.location.href);
$(document).on("click", ".purpose-btn", function(e) {
 e.preventDefault();
  $(this).text($(this).text() == 'Purpose' ? 'Close' : 'Purpose');
 $(".purpose-content").slideToggle();
});

// $("body").on('DOMSubtreeModified', "form .has-error", function() {
//   alert();
//     $(".has-error div[data-lastpass-icon-root]").removeAttr("style");
// });

// $('.previous_main_wrapper .header_block .heading').on('click', function() {
//   let $ordersWrapper = $(this).closest('.orders_wrapper');
//   if (!$ordersWrapper.hasClass('is-active')) {
//     // Close all open accordions
//     $('.previous_main_wrapper .orders_wrapper.is-active').find('.products_block').slideUp();
//     $('.previous_main_wrapper .orders_wrapper.is-active').removeClass('is-active');
      
//     // Open the clicked accordion
//     $ordersWrapper.find('.products_block').slideDown();
//     $ordersWrapper.addClass('is-active');
//   } else {
//     // Close the clicked accordion
//     $ordersWrapper.find('.products_block').slideUp();
//     $ordersWrapper.removeClass('is-active');
//   }
// });
 $('.previous_main_wrapper .header_block .heading').on('click', function() {
    let $heading = $(this);

    let $ordersWrapper = $(this).closest('.orders_wrapper');
    if (!$ordersWrapper.hasClass('is-active')) {
      // Close all open accordions
      $('.previous_main_wrapper .orders_wrapper.is-active').find('.products_block').slideUp();
      $('.previous_main_wrapper .orders_wrapper.is-active').removeClass('is-active');

      // Open the clicked accordion
      $ordersWrapper.find('.products_block').slideDown();
      $ordersWrapper.addClass('is-active');
    } else {
      // Close the clicked accordion
      $ordersWrapper.find('.products_block').slideUp();
      $ordersWrapper.removeClass('is-active');
    }

    // Scroll to the top of the page with a delay of 500 milliseconds
    setTimeout(function() {
      $('html, body').animate({ scrollTop: $heading.offset().top - 80 }, 'slow');

      // Refresh ScrollTrigger after the animation is complete
      ScrollTrigger.refresh();
    }, 500);
  });

  $(document).on('click', '.selection-criteria-wrapper .features .feature-card .feat-cta a', function(e){
    getSectionID = $(this).attr('href'); console.log('getSectionID', getSectionID);
    if(getSectionID == '#daily-discovery--section'){
      setTimeout(function() {
      $('html, body').animate({ scrollTop: $('.newsletter-daily-discovery').offset().top - 450 }, 'slow');
    }, 500);
    }
    
  });

$(document).ready(function() {

  $(document).on("input", "#phone", function(event) {
    var phoneNumber = $('#phone').val().replace(/\D/g, ''); // Remove non-numeric characters
    
    if (phoneNumber.length > 10) {
      phoneNumber = phoneNumber.substring(0, 10);
    }
    
    var maskedPhoneNumber = '';
    
    if (phoneNumber.length > 0) {
      maskedPhoneNumber = '(' + phoneNumber.substring(0, 3) + ') ';
    }
    
    if (phoneNumber.length >= 4) {
      maskedPhoneNumber += phoneNumber.substring(3, 6) + '-';
    }
    
    if (phoneNumber.length >= 7) {
      maskedPhoneNumber += phoneNumber.substring(6, 10);
    }
    
    $('#phone').val(maskedPhoneNumber);
  });

  $(document).on("keydown", "#phone", function(event) {
    if (event.key === 'Backspace') {
      // Get the current phone number value
      var phoneNumber = $(this).val().replace(/\D/g, '');
      
      // Remove the last digit from the phone number
      phoneNumber = phoneNumber.slice(0, -1);
      
      // Update the masked phone number
      var maskedPhoneNumber = '';
    
      if (phoneNumber.length > 0) {
        maskedPhoneNumber = '(' + phoneNumber.substring(0, 3) + ') ';
      }
    
      if (phoneNumber.length >= 4) {
        maskedPhoneNumber += phoneNumber.substring(3, 6) + '-';
      }
    
      if (phoneNumber.length >= 7) {
        maskedPhoneNumber += phoneNumber.substring(6, 10);
      }
    
      // Set the updated masked phone number value
      $(this).val(maskedPhoneNumber);
      
      // Prevent the default behavior of the backspace key
      event.preventDefault();
    }
  });
});



  // Change keyboard type on mobile devices
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    $('#phone').attr('type', 'tel');
  }


$(".dropbtn").on('click' , function () {
  $(this).next(".dropdown-content").slideToggle();
  $(this).toggleClass("active");
});

$('.previous_purchased_block .header_block').on('click' , function() {
  // $('.previous_purchased_block .products-main-wrapper').slideToggle();
  $(this).siblings(".products-main-wrapper").slideToggle().closest('.previous_purchased_block').toggleClass('is-active').siblings().removeClass("is-active").find(".products-main-wrapper").slideUp()
});

$('.account-table .table_toggle').on('click' , function() {
  $('.account-table .table_wrapper').slideToggle().closest('.account-table').toggleClass('is-active');
})

// Get the text content of the products_number
  var headingText = $('.products_number').text();
// Print the heading text in the data_number
  $('.data_number').text(headingText);

$(document).ready(function() {
  // Escucha el evento necesario (por ejemplo, cuando se desplaza hacia abajo en la página)
  $(window).on("scroll", function() {
    var scrollPosition = $(window).scrollTop();
    var triggerPosition = 500; // Cambia esto al valor adecuado

    if (scrollPosition >= triggerPosition) {
      // Muestra el contenido animado cambiando la propiedad "display" del contenedor
      $(".hero--template--21297292280097__8287975b-0839-411c-bc77-04627332dbef").css("display", "block");
    }
  });
});
$('.mobile_dropdown').on('click' , function() {
  $(this).toggleClass('active');
  $('.navigation_list').slideToggle();
});

$(document).on('click' , function (e) {
  const target = e.target;
  if (!$(target).is(".dropbtn") && !$(target).parents().is(".dropbtn")) {
    $(".dropdown-content").slideUp();
    $(".dropbtn").removeClass("active");
  }
});

//  $(".account_aside .navigation_list ul li a").on("click", function() {
//     let target = $(this).attr("href");
//     $("html, body").animate({
//         scrollTop: $(target).offset().top - 140
//     }, 100);
// });
$('a[href^="#"]').on("click", function(event) {
    event.preventDefault(); 
    let target = $(this).attr("href");
    let offset = 100; 
    $("html, body").animate({
        scrollTop: $(target).offset().top - offset
    }, 500);
});
if ($('.build_a_case_hero .customer_not_logged_in .logged_not_btn').hasClass('logged_not_btn')) {
  $('.build_a_case_hero .customer_not_logged_in .logged_not_btn').attr('href', '#build_a_case_join_us');
}

// if ($('main').hasClass('build-case-btn')) {
//   let startBuildDiv = $('main').find('.start-build');
//   let btn = startBuildDiv.find('a.btn');
//   btn.attr('href', '/collections/all');
// }

$(".our_team_block .grid .grid__item a").each(function() {
  if ($(this).attr("href")) {
    $(this).removeAttr("href");
  }
});

$(".our_team_block .grid .grid__item .btn").on("click", function (e) {
  e.preventDefault();
  $(".meet_team_modal").addClass("active");
  $("body").addClass("disable_scroll");
  $(".meet_team_modal .image-wrapper").html("");
  $(this)
    .closest(".grid__item")
    .find(".image-wrap img")
    .clone()
    .appendTo(".meet_team_modal .image-wrapper");
  let name = $(this).closest(".grid__item").find("h3").html();
  let specialization = $(this).closest(".grid__item").find(".text-spacing p").html();
  let description = $(this).closest(".grid__item").find(".optional-description").html();
  $(".meet_team_modal .member_name").html(name);
  $(".meet_team_modal .member_description").html(description);
  $(".meet_team_modal .member_specializations").html(specialization);
});
$("body").append(`
    <div class="meet_team_modal popup_modal">
      <div class="modal_overlay"></div>
      <div class="modal_inner_wrapper">
          <button type="button" class="close_popup">
                  <span>×</span>
          </button>
          <div class="image-wrapper">
              <img src="" alt="It's Vincent!">
          </div>
          <div class="member_content">
              <h3 class="member_name"></h3>
              <p class="member_specializations"></p>
              <p class="member_description"></p>
          </div>
      </div>
    </div>`);

$(function() {
 var pgurl = window.location.pathname;
   $(".btn_wrap .dropdown .dropdown-content a").each(function(){
      if($(this).attr("href") == pgurl || $(this).attr("href") == '' )
      $(this).addClass("active");
   })
});

$("body").append(`
    <div class="promo_popups popup_modal">
      <div class="modal_overlay"></div>
      <div class="modal_inner_wrapper">
          <button type="button" class="close_popup">
                  <span>×</span>
          </button>
          <div class="popup_content"></div>
      </div>
    </div>`);

if ($('.popup_btn').hasClass('checkbox_enable_1') || $('.popup_btn').hasClass('checkbox_enable_2')) {
  $(this).removeAttr('href');
};

$(".checkbox_enable_1").on("click", function (e) {
  e.preventDefault();
  $(".promo_popups").addClass("active");
  let popup_description = $(".popup_description_1").html();
  $(".promo_popups .popup_content").html(popup_description);
});

$(".checkbox_enable_2").on("click", function (e) {
  e.preventDefault();
  $(".promo_popups").addClass("active");
  let popup_description = $(".popup_description_2").html();
  $(".promo_popups .popup_content").html(popup_description);
});

$(".popup_block .btn").on("click", function (e) {
  e.preventDefault();
  $(".promo_popups").addClass("active");
  let popup_description = $(".popup_block .optional-description").html();
  $(".promo_popups.active .popup_content").html(popup_description);
});

$('.curated-single-wrapper .collection-hero__content .btn').on('click' , function() {
    $(".promo_popups").addClass("active");
    let curated_description = $(".curated-single-wrapper .collection-hero__content .popup_description").html();
    $(".promo_popups.active .popup_content").html(curated_description);
});

$(".close_popup , .modal_overlay").on("click", function () {
  $(".popup_modal").removeClass("active");
  $("body").removeClass("disable_scroll");
});

$(document).ready(function() {
  let maxLength = 1774;
  let text = $('.product-long-description .rte').html(); 
  let textLength = $('.product-long-description .rte').text().length;
  let excerpt = text.slice(0, maxLength);
  if(maxLength < textLength) {
    brIndex = excerpt.indexOf('<br>', maxLength);
    if (brIndex != -1) {
      excerpt = excerpt.slice(0, brIndex);
    }
    $('.product-long-description .rte').html(excerpt);
    $('.product-long-description .rte').addClass('bottom-overlay');
    $('.product-long-description .rte.bottom-overlay').parent('.product-block').append(`
        <div class="read-more-wrapper">
          <button class="read-more">Continue Reading</button>
          <button class="read-less">Read Less</button>
        </div>
    `); 
    $('.read-more').on('click' , function() {
      $('.product-long-description .rte').html(text);
      $('.read-more-wrapper').addClass('active');
    });  
    $('.read-less').on('click' , function() {
      $('.product-long-description .rte').html(excerpt);
      $('.read-more-wrapper').removeClass('active');
    });
  }  
});

// $('body.template-customers-account .cta-wrapper .btn').addClass("share_button");

$("body").append(`
    <div class="share_popup_modal">
        <div class="overlay_wrapper"></div>
        <div class="popup_inner_wrapper">
            <div class="share-header">
                <h3>Share link</h3>
                <span class="close_btn"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="250px" height="250px"><path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"/></svg></span>
            </div>
            <div class="share_buttons_wrapper">
                <h5>Share Via</h5>
                <div class="share_buttons">
                    <a href="" class="share_icon fb"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="480px" height="480px"><path fill="#039be5" d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"/><path fill="#fff" d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"/></svg></a>
                    <a href="" class="share_icon tw"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="480px" height="480px"><path fill="#03A9F4" d="M42,12.429c-1.323,0.586-2.746,0.977-4.247,1.162c1.526-0.906,2.7-2.351,3.251-4.058c-1.428,0.837-3.01,1.452-4.693,1.776C34.967,9.884,33.05,9,30.926,9c-4.08,0-7.387,3.278-7.387,7.32c0,0.572,0.067,1.129,0.193,1.67c-6.138-0.308-11.582-3.226-15.224-7.654c-0.64,1.082-1,2.349-1,3.686c0,2.541,1.301,4.778,3.285,6.096c-1.211-0.037-2.351-0.374-3.349-0.914c0,0.022,0,0.055,0,0.086c0,3.551,2.547,6.508,5.923,7.181c-0.617,0.169-1.269,0.263-1.941,0.263c-0.477,0-0.942-0.054-1.392-0.135c0.94,2.902,3.667,5.023,6.898,5.086c-2.528,1.96-5.712,3.134-9.174,3.134c-0.598,0-1.183-0.034-1.761-0.104C9.268,36.786,13.152,38,17.321,38c13.585,0,21.017-11.156,21.017-20.834c0-0.317-0.01-0.633-0.025-0.945C39.763,15.197,41.013,13.905,42,12.429"/></svg></a>
                    <a href="" class="share_icon pin"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="480px" height="480px"><circle cx="24" cy="24" r="20" fill="#E60023"/><path fill="#FFF" d="M24.4439087,11.4161377c-8.6323242,0-13.2153931,5.7946167-13.2153931,12.1030884	c0,2.9338379,1.5615234,6.5853882,4.0599976,7.7484131c0.378418,0.1762085,0.581543,0.1000366,0.668457-0.2669067	c0.0668945-0.2784424,0.4038086-1.6369019,0.5553589-2.2684326c0.0484619-0.2015381,0.0246582-0.3746338-0.1384277-0.5731201	c-0.8269653-1.0030518-1.4884644-2.8461304-1.4884644-4.5645752c0-4.4115601,3.3399658-8.6799927,9.0299683-8.6799927	c4.9130859,0,8.3530884,3.3484497,8.3530884,8.1369019c0,5.4099731-2.7322998,9.1584473-6.2869263,9.1584473	c-1.9630737,0-3.4330444-1.6238403-2.9615479-3.6153564c0.5654297-2.3769531,1.6569214-4.9415283,1.6569214-6.6584473	c0-1.5354004-0.8230591-2.8169556-2.5299683-2.8169556c-2.006958,0-3.6184692,2.0753784-3.6184692,4.8569336	c0,1.7700195,0.5984497,2.9684448,0.5984497,2.9684448s-1.9822998,8.3815308-2.3453979,9.9415283	c-0.4019775,1.72229-0.2453003,4.1416016-0.0713501,5.7233887l0,0c0.4511108,0.1768799,0.9024048,0.3537598,1.3687744,0.4981079l0,0	c0.8168945-1.3278198,2.0349731-3.5056763,2.4864502-5.2422485c0.2438354-0.9361572,1.2468872-4.7546387,1.2468872-4.7546387	c0.6515503,1.2438965,2.5561523,2.296936,4.5831299,2.296936c6.0314941,0,10.378418-5.546936,10.378418-12.4400024	C36.7738647,16.3591919,31.3823242,11.4161377,24.4439087,11.4161377z"/></svg></a>
                </div>
                <div class="copy_link">
                    <input type="text" id="copy_input">
                    <button class="copy_link_button">Copy Link</button>  
                </div>
            </div>
        </div>
    </div>
`);

$('.share_button').on('click', function(e) {
    e.preventDefault();
    $('.share_popup_modal').addClass('active');
    let shareUrl = $(this).attr('href');
    const siteURL = window.location.hostname;

    $("#copy_input").val(siteURL + shareUrl);
    
    // Facebook share button
    let facebookUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + siteURL + encodeURIComponent(shareUrl);
    $('.share_icon.fb').attr('href', facebookUrl).attr('target', '_blank');
    // Twitter share button
    let twitterUrl = 'https://twitter.com/share?url=' + siteURL + encodeURIComponent(shareUrl);
    $('.share_icon.tw').attr('href', twitterUrl).attr('target', '_blank');
    // Pinit share button
    let pinitUrl = 'http://pinterest.com/pinthis?url=' + siteURL + encodeURIComponent(shareUrl);
    $('.share_icon.pin').attr('href', pinitUrl).attr('target', '_blank');
    
});

$('.close_btn , .overlay_wrapper , .share_icon.pin , .share_icon.tw , .share_icon.fb').on('click' , function() {
    $('.share_popup_modal').removeClass('active');
    $('.copy_link_button').text("Copy Link");
});

$(".copy_link_button").on('click' , function() {
    let $copyButton = $(this);
    let inputValue = $("#copy_input").val();
    navigator.clipboard.writeText(inputValue).then(function() {
        $copyButton.text("Text Copied");
    });
});


$("#birthday").on("input",function(event) {
    let birthdayValue = new Date($("#birthday").val()).getTime();
    let minAge = new Date();
    minAge.setFullYear(minAge.getFullYear() - 21);
    minAge.setHours(0, 0, 0, 0);

    if (birthdayValue > minAge.getTime()) {
        event.preventDefault();
      $(".error-msg").addClass("active");
        
    } else {
      $(".error-msg").removeClass("active");
        let currentDate = new Date();
        let formattedDate = currentDate.getFullYear() + "-" + (currentDate.getMonth() + 1) + "-" + currentDate.getDate();
        $("#SignupDate").val(formattedDate);
    }
});

$("#register-submit").on("click", function(event) {
  let birthdayValue = new Date($("#birthday").val()).getTime();
  let minAge = new Date();
  minAge.setFullYear(minAge.getFullYear() - 21);
  minAge.setHours(0, 0, 0, 0);

  if (birthdayValue > minAge.getTime()) {
    event.preventDefault();
    $(".error-msg").addClass("active");
  } else {
    $(".error-msg").removeClass("active");
  }
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

 var $popup = $(`
        <div id="confirmation-popup" class="popup_modal">
        <div class="modal_overlay"></div>
          <div class="popup-content modal_inner_wrapper">
            <h4 class="heading" style="text-transform:inherit !important">You are about to be redirected to an external site.</h4>
           <div class="buttons_wrapper">
            <button id="cancel-redirect" class="btn btn-small">Cancel</button>
            <button id="confirm-redirect" class="btn btn-small">Continue</button>
            </div>
          </div>
        </div>
      `);

    var $confirmButton = $popup.find('#confirm-redirect');
    var $cancelButton = $popup.find('#cancel-redirect');
    var redirectLink = '';

    $('body').append($popup); // Append the popup to the body element

    $('.testimonials-section a').click(function(e) {
      var link = $(this).attr('href');
      var isExternal = (new URL(link).host !== location.host);

      // Check if the link is external
      if (isExternal) {
        e.preventDefault(); // Prevent the default link behavior
        redirectLink = link;
        $popup.addClass('active');
        $('body').addClass('disable_scroll')
      }
    });

    $confirmButton.click(function() {
      if (redirectLink) {
        window.open(redirectLink, '_blank');
      }
      $popup.removeClass('active');
      $("body").removeClass("disable_scroll");
    });

    $cancelButton.click(function() {
      redirectLink = '';
      $popup.removeClass('active');
      $("body").removeClass("disable_scroll");
    });
    
  $(".close_popup , .modal_overlay").on("click", function () {
  $(".popup_modal").removeClass("active");
  $("body").removeClass("disable_scroll");
});


const matchHeightElements = [
    '.home-boxes .grid__item h3',
    '.cta-wrapper .grid__item h3',
    '.home-boxes .grid__item .rte-setting',
    '.wine-cards .grid__item .rte-setting',
    '.cta-wrapper .grid__item .rte-setting'
];
// Apply matchHeight to a single element
function doMatchHeight( element ) {
    $(element).matchHeight({
        byRow: true,
        property: 'min-height',
    });
}
// Apply match height to all the elements
$(window).on('load', function() {
    matchHeightElements.forEach( doMatchHeight );
});

   $(document).ready(function () {
      const itemsPerPage = 30;
      let currentPage = 1;
      let originalTableRows;

      // Function to display the data for the current page
      function displayData(page) {
        const startIndex = (page - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const tableBody = $(".account-table tbody");

        // Clear the previous data
        tableBody.empty();

        // Get the relevant rows from the cached original table rows
        const relevantRows = originalTableRows.slice(startIndex, endIndex);

        // Append the relevant rows to the new table
        tableBody.append(relevantRows);
      }

      // Function to create pagination links
      function createPaginationLinks(totalPages) {
        const paginationContainer = $("#pagination-buttons");
        const prevBtn = $("#prevBtn");
        const nextBtn = $("#nextBtn");
        const pageNumber = $("#pageNumber");

        // Clear previous pagination links
        paginationContainer.empty();

        // Add the Previous button
        prevBtn.on("click", function () {
          if (currentPage > 1) {
            currentPage--;
            displayData(currentPage);
            pageNumber.text(currentPage);
            updatePaginationButtons(totalPages);
            updateCurrentPageLink();
          }
        });
        paginationContainer.append(prevBtn);

        // Loop to create pagination links
        for (let page = 1; page <= totalPages; page++) {
          let link = $("<span>").attr("class", "page").text(page);
          link.on("click", function () {
            currentPage = page;
            displayData(page);
            pageNumber.text(page);
            updatePaginationButtons(totalPages);
            updateCurrentPageLink();
          });

          paginationContainer.append(link);
        }

        // Add the Next button
        nextBtn.on("click", function () {
          if (currentPage < totalPages) {
            currentPage++;
            displayData(currentPage);
            pageNumber.text(currentPage);
            updatePaginationButtons(totalPages);
            updateCurrentPageLink();
          }
        });
        paginationContainer.append(nextBtn);

        // Create the page number span and add it to the pagination container
        pageNumber.text(currentPage);
        paginationContainer.append(pageNumber);

        // Initial pagination buttons setup
        updatePaginationButtons(totalPages);
        updateCurrentPageLink();
      }

      // Function to update pagination buttons state
      function updatePaginationButtons(totalPages) {
        const prevBtn = $("#prevBtn");
        const nextBtn = $("#nextBtn");

        if (currentPage === 1) {
          prevBtn.prop("disabled", true);
        } else {
          prevBtn.prop("disabled", false);
        }

        if (currentPage === totalPages) {
          nextBtn.prop("disabled", true);
        } else {
          nextBtn.prop("disabled", false);
        }
      }

      // Function to update the "current" class for the active page link
      function updateCurrentPageLink() {
        $(".page").removeClass("active");
        $("#pagination-buttons .page").eq(currentPage).addClass("active");
      }

      // Cache the original table rows
      originalTableRows = $(".account-table tbody tr").clone();

      // Calculate the total number of pages based on the existing rows in the table
      const totalRows = originalTableRows.length;
      const totalPages = Math.ceil(totalRows / itemsPerPage);

      // Initially display the first page
      displayData(1);

      // Create pagination links
      createPaginationLinks(totalPages);

    });

setTimeout(function(){
  $(document).find('.custom_product_list_section .grid__item.grid-product[data-product-url="'+$('body').attr('data-url')+'"]').remove();
},1000)
 

$(window).on('load', function(){
  console.log('window Loaded')
   
  if($('body').attr('data-template') == 'wine-clubs-for-invited-ga'){
    $('body').removeAttr('data-aos-easing data-aos-duration data-aos-delay');
  }
})